var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsageSkeletonTablet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 700 994"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#usage-skeleton-tablet_svg__b)",
  clipPath: "url(#usage-skeleton-tablet_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 305,
  height: 50,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 260,
  height: 50,
  x: 440,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 374,
  height: 56,
  y: 90,
  rx: 28
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 328,
  y: 769,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 268,
  y: 769,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 388,
  y: 769,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 20,
  y: 781,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 20,
  x: 540,
  y: 781,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 141,
  y: 853,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 187,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 237.182,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 287.364,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 337.545,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 387.727,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 437.909,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 488.091,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 538.273,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 588.455,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 638.636,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 40.182,
  y: 688.818,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "usage-skeleton-tablet_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "usage-skeleton-tablet_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h700v994H0z"
})))));
export { SvgUsageSkeletonTablet as ReactComponent };
export default __webpack_public_path__ + "static/media/usage-skeleton-tablet.1383cf87d1fbb34229a8.svg";